import { createStructuredSelector } from 'reselect'
import { connect } from 'react-redux'
import Selectors from '../selectors'
const mapStateToProps = createStructuredSelector({
  avatarUrl: Selectors.getCollectionOwnerAvatar,
  collectionCount: Selectors.getCollectionCount,
  description: Selectors.getCollectionDescription,
  name: Selectors.getCollectionOwnerName,
  ownerId: Selectors.getOwnerId,
  ownerTitle: Selectors.getCollectionOwnerTitle,
  title: Selectors.getCollectionTitle,
})

const mapDispatchToProps = (dispatch) => ({})

export type ConnectorProps = {
  avatarUrl: string
  collectionCount: number
  collectionId: string
  description: string
  name: string
  ownerId: string
  ownerTitle: string
  title: string
}
export default connect(mapStateToProps, mapDispatchToProps) // Component Calls Connect